<template>
  <form @submit.prevent="handleSubmit">
    <modal-card title="Add New Collection" style="margin: 0 auto;" contains-dropdown>

      <b-field label="Name">
        <b-input type="text" @blur="getSLug" v-model="form.name"></b-input>
      </b-field>

      <b-field label="Slug">
        <b-input type="text" v-model="form.slug" readonly></b-input>
      </b-field>

      <div class="columns">
        <div class="column is-6">
          <b-field label="Amount">
            <b-input type="number" v-model="form.amount"></b-input>
          </b-field>
        </div>

        <div class="column is-6">
          <b-field label="Order">
            <b-input type="number" v-model="form.order"></b-input>
          </b-field>
        </div>
      </div>

      <div class="columns">
        <div class="column is-6">
          <b-field label="Type">
            <b-select type="text" v-model="form.type" expanded>
              <option value="magazine">
                Magazine
              </option>
              <option value="issue">
                Issue
              </option>
              <option value="feed">
                Feed
              </option>
            </b-select>
          </b-field>
        </div>

        <div class="column is-6">
          <b-field label="Language">
            <b-select v-model="form.locale" expanded>
              <option :value="key" v-for="(label, key) in languages" :key="key">
                {{ label }}
              </option>
            </b-select>
          </b-field>
        </div>
      </div>

      <b-field label="Title">
        <b-input type="text" v-model="form.title"></b-input>
      </b-field>

      <b-field label="Title(MN)">
        <b-input type="text" v-model="form.mn_title"></b-input>
      </b-field>


      <div slot="foot">
        <button type="button" class="button" @click="$parent.close()">
          Close
        </button>

        <button
          class="button is-primary"
          :class="{ 'is-loading': form.processing }"
        >
          Add Collection
        </button>
      </div>
    </modal-card>
  </form>
</template>

<script>

import {getActiveLanguages} from "../../../../../data/languages";

export default {
  props: {
    added: {
      type: Function,
      required: true
    }
  },
  data() {
    let languages = getActiveLanguages();

    return {
      form: new window.Form({
        name: null,
        slug: null,
        title: null,
        type: 'issue',
        mn_title: null,
        order: 1,
        amount: 6,
        locale: 'en',
        is_added: true,
      }),
      languages
    };
  },
  methods: {
    handleSubmit() {
      this.form.post("/api/collection/create").then(this.whenAdded);
    },

    getSLug() {
      this.form.slug = this.form.name.replace(/\s+/g, '-').toLowerCase();
    },

    whenAdded(collection) {
      this.added(collection.data);
      this.$buefy.toast.open("New collection has been added.");
      this.$parent.close();
    }
  }
};
</script>
